<template>
  <div class="page-add">
    <div class="add-title">班级详情</div>
    <el-form class="form" size="small" label-position="right" label-width="120px" :rules="rules" :model="classForm"
      ref="classForm" :disabled="!!noEdit">
      <el-row>
        <el-col :span="12">
          <el-form-item label="班级名称：" prop="className">

            <el-input :class="{ 'className-style': !editId }" v-model="classForm.classYearName" placeholder="请输入班级名称">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主办单位：" prop="organizer">
            <el-input v-model="classForm.organizer" placeholder="请输入主办单位"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="班级类型：" prop="trainType">
            <el-cascader v-model="classForm.trainType" :options="treeCdata" :props="props" placeholder="请选择班级类型"
              style="width: 100%">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="办班级别：" prop="classLevel" required>
            <el-select class="form-select" v-model="classForm.classLevel" placeholder="请选择办班级别">
              <el-option v-for="item in classLevelData" :key="item.paramKey" :label="item.paramValue"
                :value="Number(item.paramKey)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="报名方式：" prop="enrollMode" :rules="[rulesFactory.required('请选择报名方式')]">
            <el-radio-group v-model="classForm.enrollMode">
              <el-radio :label="1">联络员报名</el-radio>
              <el-radio :label="0">自主报名</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="报名部门：" prop="enrollDeptNames" :rules="[rulesFactory.required('请选择报名部门')]">
            <el-input class="form-dept" v-model="classForm.enrollDeptNames" placeholder="请选择可报名部门"></el-input>
            <el-button class="button-dept" @click="selectDep">选择</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item class="scale" label="报名条件：" prop="cadreLevelList" v-if="classForm.enrollMode != 1">
            <WYSelect v-model="classForm.cadreLevelList"  placeholder="请选择报名条件"
              :options="cadreTypeAttr" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="报名时间：" prop="enrollTime" required>
            <el-date-picker unlink-panels v-model="classForm.enrollTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"><el-form-item label="培训时间：" prop="trainTime" :rules="[rulesFactory.required('请选择培训时间')]">
            <el-date-picker unlink-panels v-model="classForm.trainTime" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="班级简介：" prop="desc" :rules="[
              rulesFactory.required('请输入班级简介'),
              rulesFactory.size('最多输入200个字', 0, 200),
            ]">
            <el-input type="textarea" rows="4" v-model="classForm.desc" placeholder="请输入班级简介"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div style="width: 95%">
          <el-col :span="8">
            <el-form-item label="配图：" prop="webCover" :rules="[rulesFactory.required('请选择WEB封面')]">
              <div v-if="classForm.webCover" id="video-output" @mouseenter="showCover1 = true"
                @mouseleave="showCover1 = false">
                <img :src="classForm.webCover" class="avatar" />
                <div v-show="showCover1" class="cover-bg">
                  <i class="el-icon-zoom-in delete" @click.stop="showViewer1 = true"></i>
                </div>
              </div>
              <el-upload v-else action="" class="avatar-uploader" :show-file-list="false" :http-request="uploadCover1"
                accept="png,jpg,jpeg" :limit="1" ref="coverUpload1">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!classForm.webCover" class="upload-text">上传图片</label>
              </el-upload>
              <div class="upload_tip">
                <p>WEB封面</p>
                <p class="img_tip">建议尺寸：1200px*600px（或2:1）</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="scale" prop="appCover" :rules="[rulesFactory.required('请选择APP封面')]">
              <div v-if="classForm.appCover" id="video-output" @mouseenter="showCover2 = true"
                @mouseleave="showCover2 = false">
                <img :src="classForm.appCover" class="avatar" />
                <div v-show="showCover2" class="cover-bg">
                  <i class="el-icon-zoom-in delete" @click.stop="showViewer2 = true"></i>
                </div>
              </div>
              <el-upload v-else action="" class="avatar-uploader" :show-file-list="false" :http-request="uploadCover2"
                accept="png,jpg,jpeg" :limit="1" ref="coverUpload2">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!classForm.appCover" class="upload-text">上传图片</label>
              </el-upload>
              <div class="upload_tip">
                <p>APP封面</p>
                <p class="img_tip">建议尺寸：1125px*468px（或12:5）</p>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="承办单位：" :rules="[rulesFactory.required('请选择APP封面')]">
            <take-unit @getTakeUnit="getTakeUnit" :initUnits="classForm.undertakeUnitList" :noEdit="noEdit"
              v-if="loadFlag" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item :label="classForm.enrollMode == 1 ? '计划人数：' : '限制名额：'" prop="planStuNum" :rules="[rulesFactory.required('请选择限制名额')]">
            <el-input-number v-model="classForm.planStuNum" :min="1" :step="10"
              label="描述文字"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="结业要求：" prop="graduationRequirements">
            <el-input type="textarea" placeholder="请输入结业要求" v-model="classForm.graduationRequirements" rows="5"
              maxlength="200" show-word-limit>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="班级管理员：" prop="auditUserIds" :rules="[rulesFactory.required('请选择班级管理员')]">
            <el-input v-model="classForm.auditUserName" />
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <el-row>
      <el-col class="form-text-center">
        <back-button :floatLeft="false" :pathOptions="{ path: '/onlineClass' }" />
      </el-col>
    </el-row>
    <!-- 图片预览 -->
    <el-image-viewer v-if="showViewer1" :on-close="
        () => {
          showViewer1 = false;
        }
      " :url-list="[classForm.webCover]" />
    <el-image-viewer v-if="showViewer2" :on-close="
        () => {
          showViewer2 = false;
        }
      " :url-list="[classForm.appCover]" />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { Confirm } from "@/components/Confirm";
import {
  getStudyClassInfo,
} from "@/api/class";
import { treeChildVos } from "@/api/classOffline";
import { getSysParamByTypes, getBusinessParamByTypes } from "@/api/sysParam";
import FileHandler from "@/utils/file";
import vue from "../../../main";
import moment from "moment";
import rulesFactory from "@/utils/rules";
import TakeUnit from "@/views/offlineClass/add/takeUnit";
import { getItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index";
import WYSelect from "@/components/wySelect";

export default {
  name: "classDetail",
  components: { ElImageViewer, TakeUnit, BackButton, WYSelect },
  data() {
    return {
      noEdit: true,
      props: {
        //树形
        value: "key",
        label: "name",
        children: "children",
        // checkStrictly: true,
      },
      treeCdata: [],
      loadFlag: false,
      editId: null,
      rulesFactory,
      defaultCheckedKeys: [],
      trainTypeData: [],
      classLevelData: [],
      publicData: [],
      enrollModeData: [],
      currentPeriod: 0,
      classForm: {
        classYear: "",
        trainType: 0,
        classLevel: 0,
        isParty: 1, // 非党校=1 ，党校=2
        groupSourceType: 1, // 1网院 2党校
        enrollDeptNames: "",
        undertakeUnitList: [],
        enrollMode: 1,
      },
      showCover1: false,
      showCover2: false,
      showViewer1: false,
      showViewer2: false,
      rules: {
        className: [
          rulesFactory.required("请输入班级名称"),
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        organizer: [
          rulesFactory.required("请选择主办单位"),
        ],
        trainType: [rulesFactory.required("请选择班级类型")],

        classLevel: [rulesFactory.required("请选择办班级别")],
        graduationRequirements: [
          rulesFactory.required("请输入结业要求"),
          rulesFactory.size("最多输入200个字", 0, 200),
        ],
      },
      isShowDept: false,
      cadreTypeAttr: [],
    };
  },
  created() {
    this.editId = this.$route.query.id;
    this.deptLevelCode = getItem("deptLevelCode");
    this.getTypeList(this.deptLevelCode);
    if (this.editId) {
      getStudyClassInfo(this.editId).then((res) => {
        if (!res || res.code != 0) return;
        let obj = Object.assign({}, res.data);
        let auditUserIds = obj.auditUserIds;
        if (auditUserIds) {
          for (let i = 0; i < auditUserIds.length; i++) {
            auditUserIds[i] = String(auditUserIds[i]);
          }
        }
        // 格式化时间
        obj.trainTime = [moment(obj.trainStartTime), moment(obj.trainEndTime)];
        obj.enrollTime = [
          moment(obj.enrollStartTime),
          moment(obj.enrollEndTime),
        ];
        obj.classYearName = obj.classYear + '年' + obj.className;
        this.classForm = obj;
        this.loadFlag = true;
        this.defaultCheckedKeys = this.classForm.enrollDeptIds;
        treeChildVos({ type: "CLASS_TYPE_UP" }).then((res) => {
          if (!res || res.code != 0) return;
          let tg = this.classForm.trainType;
          let tt = [0, String(tg)];
          this.treeCdata = res.data || [];
          this.treeCdata.forEach((x) => {
            if (x.children) {
              x.children.forEach((y) => {
                if (y.key == tt[1]) {
                  tt[0] = x.key;
                }
              });
            }
          });
          this.classForm.trainType = tt;
        });
      });
      this.rules.className = [];
    } else {
      this.loadFlag = true;
      this.addTrainInfoDto();
      let date = new Date();
      this.classForm.classYear = date.getFullYear().toString();
      treeChildVos({ type: "CLASS_TYPE_UP" }).then((res) => {
        if (!res || res.code != 0) return;
        this.treeCdata = res.data;
      });
    }
    this.getSysParamByTypes([
      "CLASS_LEVEL_TYPE",
      "CLASS_TYPE_UP",
      "ENROLL_MODEL",
    ]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // 获取办班级别数据字典
        this.classLevelData = res.data["CLASS_LEVEL_TYPE"];
        // 获取培训类型数据字典
        this.trainTypeData = res.data["CLASS_TYPE_UP"];
        // 获取报名方式数据字典
        this.enrollModeData = res.data["ENROLL_MODEL"];
        if (!this.edit) {
          if (this.classLevelData.length > 0) {
            // 设置默认选中
            this.classForm.classLevel = Number(this.classLevelData[0].paramKey);
          }
          if (this.trainTypeData.length > 0) {
            // 设置默认选中
            this.classForm.trainType = Number(this.trainTypeData[0].paramKey);
          }
        }
      });
    },
    getTypeList(deptLevelCode) {
      let types = ['CLASS_CADRE_LEVEL'];
      getBusinessParamByTypes({ types, deptLevelCode }).then((res) => {
        if (!res || res.code != 0) return;
        this.cadreTypeAttr = res.data["CLASS_CADRE_LEVEL"]
      });
    },
    getTakeUnit(val) {
      this.classForm.undertakeUnitList = val;
    },
    enrollDeptSelected(dept) {
      console.log("deddd:", dept);
      this.classForm.enrollDeptIds = dept.ids;
      this.defaultCheckedKeys = dept.ids;
      this.classForm.enrollDeptNames = dept.names.join(",");
    },
    selectDep() {
      vue.$emit("selectDep");
    },
    // 初始化当前期次数据
    addTrainInfoDto() {
      this.classForm = {
        desc: "",
        enrollMode: 0,
        enrollDeptNames: "",
        enrollDeptIds: [],
        auditUserName: "",
        auditUserIds: [],
        periodNum: 1,
        planStuNum: 1,
        trainPlace: "",
        undertakeUnit: "",
        undertakeUnitList: [],
        webCover: "",
        appCover: "",
        enrollAttachment: "",
        enrollStartTime: "",
        enrollEndTime: "",
        trainStartTime: "",
        trainEndTime: "",
        isParty: 1, // 非党校=1 ，党校=2
        groupSourceType: 1, // 1网院 2党校
        classLevel: 0,
      };
    },
    // 重置表单数据
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        let className = this.classForm.className;
        this.$refs["classForm"].resetFields();
        this.classForm.className = className;
        this.classForm = {
          desc: "",
          enrollMode: 0,
          enrollDeptNames: "",
          enrollDeptIds: [],
          auditUserName: "",
          auditUserIds: [],
          periodNum: 1,
          planStuNum: 1,
          trainPlace: "",
          undertakeUnit: "",
          undertakeUnitList: [],
          webCover: "",
          appCover: "",
          enrollAttachment: "",
          enrollStartTime: "",
          enrollEndTime: "",
          trainStartTime: "",
          trainEndTime: "",
          classLevel: 0,
        };
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 删除封面
    deleteCover(index) {
      switch (index) {
        case 1: {
          this.classForm.webCover = "";
          break;
        }
        case 2: {
          this.classForm.appCover = "";
          break;
        }
      }
    },
    // 上传WEB封面
    async uploadCover1(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload1"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`subject/img`, file).then((res) => {
        const { url } = res;
        this.classForm.webCover = url;
      });
    },
    // 上传封面
    async uploadCover2(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload2"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`subject/img`, file).then((res) => {
        const { url } = res;
        this.classForm.appCover = url;
      });
    },

  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}
/deep/ .scale .el-input {
  color: $textColor;
  font-size: 12px;
}
.form-select {
  width: 100%;
}
/deep/ .el-form-item__content {
  .form-dept {
    width: calc(50% - 139px);
    font-size: inherit;
  }
  .button-dept {
    margin-left: 10px;
    padding: 9px 15px;
    width: 79px;
  }
  .el-select.select {
    width: 100% !important;
  }
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 280px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 280px;
  height: 160px;
  display: block;
  object-fit: contain;
}
.upload-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: $textColor;
  font-size: 13px;
}
.year_style {
  width: 100px;
  margin-right: 10px;
  color: #51627d;
}
#video-output {
  width: 280px;
  height: 160px;
  position: relative;
  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;
    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
.upload_tip {
  width: 280px;
  text-align: center;
  margin-top: 10px;
}
.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}
.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
.className-style {
  width: calc(100% - 110px);
}
/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}
.form-text-center {
  text-align: center !important;
}
.tips {
  width: 720px;
  background: #ececec;
  border-radius: 4px;
  padding: 4px;
  p {
    line-height: 22px;
    margin: 0;
    padding: 0;
  }
}
</style>
